module.exports = __webpack_public_path__ + "about.33e1834a.png";